// extracted by mini-css-extract-plugin
export default {"SimpleCard":"SimpleCard-styles__SimpleCard__cBL_1","SimpleCard__body":"SimpleCard-styles__SimpleCard__body__AnAPp","SimpleCard__title":"SimpleCard-styles__SimpleCard__title__lHcUg"};